import { render, staticRenderFns } from "./FixedPriceTaskServiceGridRow.vue?vue&type=template&id=23b8b744&scoped=true"
import script from "./FixedPriceTaskServiceGridRow.vue?vue&type=script&lang=js"
export * from "./FixedPriceTaskServiceGridRow.vue?vue&type=script&lang=js"
import style0 from "./FixedPriceTaskServiceGridRow.vue?vue&type=style&index=0&id=23b8b744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b8b744",
  null
  
)

export default component.exports